import SessionEvent from './SessionEvent';

export default SessionEvent;
